<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title> Tasks — {{ data?.mitigationId }} </template>

    <template #body>
      <div class="modal-scroll-body">
        <!-- No Data -->
        <div class="text-center py-5" v-if="!taskList.length">
          <p class="text-muted">No tasks available for this mitigation</p>
        </div>

        <!-- Table -->
        <div v-else>
          <div class="table-responsive">
            <div class="ibox-title style_2 d-flex justify-content-between">
              <h5 class="m-0">{{ $t("navigations.tasks") }}</h5>
              <div class="position-relative align-self-center">
                <img
                  src="@/assets/img/create.png"
                  width="17"
                  alt="Add Task"
                  style="cursor: pointer"
                  @click="
                    () => {
                      selectedTask = null;
                      showAddTaskModal = true;
                    }
                  "
                />
                <div class="tool-tip mt-2">Add Tasks</div>
              </div>
            </div>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>Task ID</th>
                  <th>Task Description</th>
                  <th>Assigned Role</th>
                  <th>Cadence</th>
                  <th class="text-center">Edit</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="task in taskList" :key="task.taskId">
                  <td>
                    {{ task.taskId }}
                    <!-- <span class="badge bg-light text-dark">{{ task.taskId }}</span> -->
                  </td>
                  <td class="description-cell">
                    <span>{{
                      task.expanded
                        ? task.taskDescription
                        : truncate(task.taskDescription)
                    }}</span>
                    <a
                      v-if="
                        task.taskDescription &&
                        task.taskDescription.length > 120
                      "
                      class="more-less-link ms-1"
                      @click="toggleExpand(task)"
                    >
                      {{ task.expanded ? "less" : "more" }}
                    </a>
                  </td>
                  <td>{{ task.assignedRole }}</td>
                  <td>
                    <span
                      :class="
                        'badge badge-' + getCadenceBadgeClass(task.cadence)
                      "
                    >
                      {{ task.cadence }}
                    </span>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      title="Edit Task"
                      @click="openEditTask(task)"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ManageMitigationTaskModal
        v-if="showAddTaskModal"
        :studyId="data.studyId"
        :ctqId="data.ctqId"
        :mitigationId="data.id"
        :mitigationCode ="data.mitigationId"
        :taskItem="selectedTask"
        @closeModal="
          showAddTaskModal = false;
          selectedTask = null;
        "
        @taskSaved="onTaskSaved"
      />
    </template>
  </customModal>
</template>

<script src="./MitigationTasksModal.js"></script>

<style scoped>
.modal-scroll-body {
  padding: 10px 0;
  max-height: 60vh;
  overflow-y: auto;
}

.description-cell {
  max-width: 420px;
  white-space: normal;
  word-break: break-word;
  /* font-size: 0.85rem;
    color: #444; */
}

.badge {
    padding: 2px 12px;
    border-radius: 4px;
    font-size: 0.70rem;
    font-weight: 500;
    display: inline-block;
    white-space: nowrap;
}

.badge-primary {
  background-color: #cce5ff;
  color: #004085;
}

.badge-info {
  background-color: #d1ecf1;
  color: #0c5460;
}

.badge-warning {
  background-color: #fff3cd;
  color: #856404;
}

.badge-secondary {
  background-color: #e2e3e5;
  color: #383d41;
}

.badge-light {
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #dee2e6;
}

.more-less-link {
  color: #618bd7 !important;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
}

.more-less-link:hover {
  text-decoration: underline !important;
}
.position-relative .tool-tip{
  right: 18px;
  top: 0px;
}
.ibox-title{
  padding: 8px 15px 8px 15px !important;
  min-height: 34px;  
}
</style>